import { BarChart } from '@/components/charts/bar-chart';
import { DonutChart } from '@/components/charts/donut-chart';
import { LineChart } from '@/components/charts/line-chart';

import type { ChartSpec } from '../asistente.types';

interface AssistantChartProps {
  spec: ChartSpec;
}

/**
 * Dibuja la especificación de gráfico que envía el backend.
 *
 * El backend decide el tipo (`line` | `bar` | `doughnut` | `pie`) a partir del
 * resultado real de la herramienta, así que aquí sólo se elige el componente.
 */
export function AssistantChart({ spec }: AssistantChartProps) {
  if (!spec || !Array.isArray(spec.labels) || spec.labels.length === 0) return null;

  const series = (spec.series ?? []).filter((serie) => serie && Array.isArray(serie.data));
  if (series.length === 0) return null;

  if (spec.type === 'doughnut' || spec.type === 'pie') {
    return <DonutChart title={spec.title} labels={spec.labels} series={series} format={spec.format} />;
  }

  if (spec.type === 'line') {
    return (
      <LineChart
        title={spec.title}
        labels={spec.labels}
        series={series}
        format={spec.format}
        spanGaps={Boolean(spec.spanGaps)}
      />
    );
  }

  return (
    <BarChart
      title={spec.title}
      labels={spec.labels}
      series={series}
      format={spec.format}
      stacked={Boolean(spec.stacked)}
    />
  );
}
